import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var SalesYearMonthWiseRes;
export const SalesYearMonthWiseTodo = createAsyncThunk('SalesYearMonthWise', async (data) => {
    

    var type = localStorage.getItem('type')
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'sales_month_years_wise',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
            }
        })
        return SalesYearMonthWiseRes = res.data

    } catch (error) {
        return SalesYearMonthWiseRes = error.response.data
    }
});

const SalesYearMonthWiseSlice = createSlice({
    name: 'SalesYearMonthWise',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(SalesYearMonthWiseTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(SalesYearMonthWiseTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default SalesYearMonthWiseSlice.reducer; 